module.exports = __webpack_public_path__ + "img/logo-header.e7173bd7.png";